<template>
    <main class="cart">
        <div class="container-fluid">
            <section class="page-header">
                <h1><span>Оплата и доставка</span></h1>
            </section>

            <div class="row q-col-gutter-lg">
                <div class="col-12 col-sm-7 col-md-8">
                    <div class="cart-delivery">
                        <cart-delivery-method></cart-delivery-method>

                        <cart-delivery-payment></cart-delivery-payment>

                        <cart-delivery-contact></cart-delivery-contact>
                    </div>
                </div>

                <div class="col-12 col-sm-5 col-md-4">
                    <cart-total :step="2" :disabled="!submittable"></cart-total>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
    import { mapState, mapGetters } from 'vuex';

    export default {
        name: 'CartDelivery',
        props: ['products', 'promoCode', 'maxAllowedItemsCount'],
        mounted () {
            let _this = this;

            _this.$store.commit('cart/setItems', _this.products);
            _this.$store.commit('cart/setPromoCode', _this.promoCode);
            _this.$store.commit('cart/setMaxAllowedItemsCount', _this.maxAllowedItemsCount);

            _this.$store.commit('geo/loadDeliveryDataOnCityChange');

            _this.loadData();
        },
        watch: {
            getMaxAllowedItemsCount (val, oldVal) {
                if (this.itemsCount > val) {
                    window.location.href = '/cart';
                }
            }
        },
        methods: {
            loadData () {
                let _this = this;
                axios.get('/cart/delivery-data')
                    .then(response => {
                        _this.$store.commit('delivery/setDeliveries', response.data.deliveries);
                        _this.$store.commit('delivery/setPickupPoints', response.data.pickupPoints);
                        _this.$store.commit('customer/setAddresses', response.data.addresses);
                        _this.$store.dispatch('cart/setCustomerData', response.data.customer);
                    });
            },
            blurPhoneNumber () {
                this.fillMask = false;

                if (!this.validatePhoneNumber(this.phone_number)) {
                    this.phone_number = '';
                }
            },
        },
        computed: {
            ...mapState('geo', [
                'location',
            ]),
            ...mapState('cart', [
                'itemsCount',
            ]),
            ...mapGetters('cart', [
                'stepOneValid',
                'stepTwoValid',
                'submittable',
                'getMaxAllowedItemsCount'
            ]),
            phone_number: {
                get () {
                    return this.$store.state.auth.login.phone_number;
                },
                set (value) {
                    this.$store.commit('auth/setFormValue', {
                        key: 'phone_number',
                        value: value
                    });
                }
            },
        }
    }
</script>

